// 日付の表示。日付と基準のタイムゾーンはサーバーが決める（現在は全員 Asia/Tokyo）。
// クライアントは「今日」を自分で計算せず、サーバーが返した local_date と timezone を表示する。
// 将来、プロフィールでタイムゾーンを設定できるようになっても、timezone の値が変わるだけで済む。

type Translate = (key: string, options?: Record<string, unknown>) => string;

// i18n に表示名がある基準。辞書にない値は、IANA 名をそのまま表示する。
const KNOWN_ZONES: Record<string, string> = {
  "Asia/Tokyo": "futureBoard.timezone.tokyo",
};

export const timezoneNameKey = (timezone: string): string | null => KNOWN_ZONES[timezone] ?? null;

// 「日付は東京時間（日本標準時）で記録されます」
export function timezoneNotice(timezone: string, t: Translate): string {
  const key = timezoneNameKey(timezone);
  const zone = key ? t(key) : timezone;
  return t("futureBoard.timezone.notice", { zone });
}

// YYYY-MM-DD を、端末の時刻に左右されずに表示する（その日付そのものを書式にする）。
export function formatLocalDate(localDate: string, locale: string): string {
  const match = localDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return localDate;
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));
  try {
    return new Intl.DateTimeFormat(locale, { timeZone: "UTC", year: "numeric", month: "long", day: "numeric" }).format(date);
  } catch {
    return localDate;
  }
}

// 日時（created_at など）を、サーバーが返した基準のタイムゾーンで表示する。基準が不正なら UTC。
export function formatDateTime(iso: string, locale: string, timezone: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
  try {
    return new Intl.DateTimeFormat(locale, { ...options, timeZone: timezone }).format(date);
  } catch {
    return new Intl.DateTimeFormat(locale, { ...options, timeZone: "UTC" }).format(date);
  }
}
